export const COLD_SYNC_SINCE = "1970-01-01T00:00:00.000Z";
